export { default } from './WelcomeSection';
